import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import StartUp from "./pages/startUp/StartUp";
import TemplateLoader from "./pages/templateLoader/TemplateLoader";
import Header from "./components/header/Header";
import "bootstrap/dist/css/bootstrap.min.css";
import FontSelector from "./pages/fontSelection/FontSelector";
import { useContext, useEffect, useState } from "react";
import ModalComponent from "./components/modal/Modal";
import ColorSelector from "./pages/colorSelection/ColorSelector";
import { AppContext } from "./components/provider/AppContext";
import AppContextDisplayer from "./components/provider/AppContextDisplayer";
import Footer from "./components/footer/Footer";
import styles from "./App.module.css";
import axios from "axios";
import { getErrorMessage } from "./ErrorUtils.tsx";
import { loadStripe } from "@stripe/stripe-js";
//QR CODE IF THE SITE IS NOT ON MOBILE
//TODO: Fix buttons and title showing and not shpwing PYW-03
//TODO: fix displayer not being properly sized when phone changes
//TODO: Show colors in the planner
//TODO: fix styling throughout
//TODO: SessionStorage instead of state since when you reload everything unsaves
//TODO: Title page needs more styling
//TODO: Colors
//TODO: Angela needs a site to basically do out of stock
//TODO: You can skip the calendar planner
//TODO: Flow size (price), Selecting templates
//TODO: Border selected then ask about calendar ((Dont forget about the description of the planner))
//TODO: Calendar none --> done
//pt2 press every 5 weeks or all together
//One page is every 5 weeks 12 months and all together 12 months
//TODO: Buttons at the bottom
//TDOD: Cricut
//TODO: No monogram
//TODO: 2 pages planners calendars can only fit 6 months every 5 weeks or all together.
//TODO: stay on task, lined and graph do not have calendar
//TODO fix l

function App() {
  const [showPlanner, setShowPlanner] = useState(false);
  const { appData } = useContext(AppContext);
  const isInStart = window.location.href.split("/")[3] === "";
  useEffect(() => {
    if (appData?.showPlanner && appData?.showPlanner === true) {
      setShowPlanner(true);
    }
    // if (JSON.parse(localStorage.getItem("appData")) !== appData) {
    //   set;
    // } else {
    //   console.error(
    //     "AppData not saved properly",
    //     localStorage.getItem("appData")
    //   );
    // }
  }, [appData]);
  // async function createPaymentLink() {
  //   const paymentLink = await stripe.paymentLinks.create({
  //     line_items: [
  //       {
  //         price: 'price_1MoC3TLkdIwHu7ixcIbKelAC',
  //         quantity: 1,
  //       },
  //     ],
  //   });
  //   console.log(paymentLink); // This is the link you share with the customer
  // }
  // createPaymentLink();
  // useEffect(() => {
  //   const fetchPaymentLink = async () => {
  //     try {
  //       const response = await axios.post('https://createpaymentlink-jgex6zds4a-uc.a.run.app', {
  //         bindColor: '12345',
  //         fontStyle: 'Jane Doe',
  //         letters: 'Thanks for your purchase!',
  //         calendar: 'Every 5 weeks',
  //       });
  //       console.log('Response:', response.data);
  //     } catch (error) {
  //       getErrorMessage(error);
  //       console.error('Error fetching payment link:', error);
  //     }
  //   };

  //   fetchPaymentLink();
  // }, []);
  const stripePromise = loadStripe(
    "pk_test_51QoDXvP80mtGD93MJ52FlsrKWCrr22Y4rEnNdLRJyG9xac43jeTp7DW36eDMyPAxvjUP8tjh3BwerM1GfsK8gkaH00LXR49z6q plan"
  ); // Use your real publishable key here

  const onPlannerModalClose = async () => {
    try {
      const response = await axios.post(
        "https://createcheckoutsession-jgex6zds4a-uc.a.run.app", // Update with your actual Firebase URL
        {
          bindColor: appData?.bindColor,
          fontStyle: appData?.fontStyle,
          letters: Object.keys(appData?.letters)
            .map((letter) => appData?.letters[letter])
            .join(""),
          calendar: "Every 5 weeks",
          cost: 25.0,
        }
      );

      if (response.data && response.data.sessionId) {
        const { sessionId } = response.data;
        const stripe = window.Stripe(
          "pk_test_51QoDXvP80mtGD93MJ52FlsrKWCrr22Y4rEnNdLRJyG9xac43jeTp7DW36eDMyPAxvjUP8tjh3BwerM1GfsK8gkaH00LXR49z6q"
        );
        await stripe.redirectToCheckout({ sessionId });
      } else {
        console.error("Error: No session ID returned");
      }
    } catch (error) {
      console.error("Error fetching payment link:", error);
    }
    setShowPlanner(false);
  };

  return (
    <div className={styles["background"]}>
      <Router>
        {!isInStart ? <Header setShowPlanner={setShowPlanner} /> : <></>}
        <div>
          <Routes>
            <Route path="/" element={<StartUp />} />
            <Route path="/colorSelection" element={<ColorSelector />} />
            <Route path="/template" element={<TemplateLoader />} />
            <Route path="/font" element={<FontSelector />} />
          </Routes>
        </div>
        {!isInStart ? <Footer /> : <></>}
        <ModalComponent
          onExit={onPlannerModalClose}
          title={"Planner Selection"}
          show={showPlanner}
          setShowPlanner={setShowPlanner}
          children={<AppContextDisplayer />}
        />
      </Router>
    </div>
  );
}

export default App;
